import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useMyTickets, useCreateTicket } from '../api/useSupport'
import { useAuthStore } from '../store/authStore'
import { TICKET_STATUS_LABEL as STATUS_LABEL, TICKET_STATUS_CSS as STATUS_CSS } from '../utils/constants'
import { getErrMsg } from '../api/client'
import toast from 'react-hot-toast'

export default function Support() {
  const user = useAuthStore((s) => s.user)
  const isFrozen = user?.status === 'frozen'
  const { data: tickets = [], isLoading } = useMyTickets()
  const [showForm, setShowForm] = useState(false)
  const [subject, setSubject] = useState('')
  const [text, setText] = useState('')
  const { mutate: create, isPending } = useCreateTicket()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!subject.trim() || !text.trim()) return
    create({ subject: subject.trim(), text: text.trim() }, {
      onSuccess: () => {
        toast.success('Обращение отправлено')
        setShowForm(false)
        setSubject('')
        setText('')
      },
      onError: (err) => toast.error(getErrMsg(err, 'Ошибка при отправке')),
    })
  }

  const dateStr = (d) => new Date(d).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
      {isFrozen && (
        <div className="mb-6 p-4 rounded-xl border border-blue-400/30 bg-blue-400/10">
          <p className="text-sm font-semibold text-blue-400 mb-1">🧊 Ваш аккаунт заморожен</p>
          {user.freeze_reason && (
            <p className="text-sm text-fg mb-0.5"><span className="text-muted">Причина:</span> {user.freeze_reason}</p>
          )}
          {user.freeze_until
            ? <p className="text-sm text-muted mb-1">До: {new Date(user.freeze_until).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
            : <p className="text-sm text-muted mb-1">Навсегда</p>
          }
          <p className="text-sm text-muted">Вы можете написать в поддержку для обжалования.</p>
        </div>
      )}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">Поддержка</h1>
        <button
          onClick={() => setShowForm((v) => !v)}
          className="px-4 py-2 rounded-xl text-sm font-bold bg-accent text-on-accent hover:opacity-90 transition-opacity"
        >
          + Новое обращение
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="mb-6 p-4 rounded-2xl bg-surface border border-line flex flex-col gap-3">
          <div>
            <label className="text-xs font-semibold text-muted mb-1 block">Тема</label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Опишите вашу проблему кратко..."
              required
              className="w-full px-3 py-2 rounded-lg text-sm outline-none bg-surface2 border border-line text-fg focus:border-accent transition-colors"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-muted mb-1 block">Сообщение</label>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Подробно опишите вашу проблему..."
              required
              rows={4}
              className="w-full px-3 py-2 rounded-lg text-sm outline-none bg-surface2 border border-line text-fg focus:border-accent transition-colors resize-none"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setShowForm(false)}
              className="px-4 py-2 rounded-lg text-sm text-muted hover:text-fg transition-colors">
              Отмена
            </button>
            <button type="submit" disabled={isPending}
              className="px-4 py-2 rounded-lg text-sm font-bold bg-accent text-on-accent disabled:opacity-50">
              Отправить
            </button>
          </div>
        </form>
      )}

      {isLoading ? (
        <div className="flex flex-col gap-2">
          {[1, 2, 3].map((i) => <div key={i} className="h-16 rounded-xl animate-pulse bg-surface" />)}
        </div>
      ) : tickets.length === 0 ? (
        <p className="text-center py-16 text-muted">Обращений пока нет</p>
      ) : (
        <div className="flex flex-col gap-2">
          {tickets.map((t) => (
            <Link
              key={t.id}
              to={`/support/${t.id}`}
              className="flex items-center justify-between gap-3 px-4 py-3 rounded-xl bg-surface border border-line hover:border-accent transition-colors"
            >
              <div className="min-w-0">
                <p className="text-sm font-semibold truncate">{t.subject}</p>
                <p className="text-xs text-muted">{dateStr(t.created_at)}</p>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full shrink-0 font-medium ${STATUS_CSS[t.status] || STATUS_CSS.closed}`}>
                {STATUS_LABEL[t.status] || t.status}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
